import {
  ContentCopy,
  Delete,
  CallSplit,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const getMatchTypeLabel = (type) => {
    const labels = {
      contains: "Contém",
      exact: "Exato",
      startsWith: "Começa",
      endsWith: "Termina",
    };
    return labels[type] || type;
  };

  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#f59e0b",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      
      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#f59e0b' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <CallSplit sx={{ width: "18px", height: "18px", color: "#f59e0b" }} />
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Condição de Texto
        </div>
      </div>
      
      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5', marginBottom: '8px' }}>
        <strong>Nome:</strong> {data?.name || "Sem nome"}
      </div>

      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5', marginBottom: '8px' }}>
        <strong>Tipo:</strong> {getMatchTypeLabel(data?.matchType)}
      </div>

      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
        <strong>Palavras:</strong> {data?.keywords ? data.keywords.split(",")[0].trim().substring(0, 20) + "..." : "Nenhuma"}
      </div>

      {/* Saída SIM */}
      <Handle
        type="source"
        position="right"
        id="yes"
        style={{
          background: "#10b981",
          width: "12px",
          height: "12px",
          top: "30%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />

      {/* Saída NÃO */}
      <Handle
        type="source"
        position="right"
        id="no"
        style={{
          background: "#ef4444",
          width: "12px",
          height: "12px",
          top: "70%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />

      {/* Labels das saídas */}
      <div
        style={{
          position: "absolute",
          right: "-35px",
          top: "25%",
          fontSize: "10px",
          fontWeight: "bold",
          color: "#10b981",
          whiteSpace: "nowrap",
        }}
      >
        ✓ SIM
      </div>
      <div
        style={{
          position: "absolute",
          right: "-35px",
          top: "65%",
          fontSize: "10px",
          fontWeight: "bold",
          color: "#ef4444",
          whiteSpace: "nowrap",
        }}
      >
        ✗ NÃO
      </div>
    </div>
  );
});
